import React from 'react'
import {connect} from 'react-redux'

class SuperVipTransfer extends React.Component {
    constructor() {
        super();
        this.state = {
            id:null
        }
    }
    componentWillReceiveProps(nextProps) {
        let pageUrl = location.href.split('?')[1];
        window.location.replace('/supervipintro/new?'+pageUrl);

    }
    render(){
        return(
            <div style={{background:'#fff',height:'100vh'}}></div>
        )
    }
}

export default connect(state => ({
    account: state.account
}))(SuperVipTransfer)


// WEBPACK FOOTER //
// ./src/pages/SuperVipNewPage/SuperVipTransfer.js